import React, { useState } from 'react';
import { X } from 'lucide-react';
import VoiceInputButton from '../../../components/ui/VoiceInputButton';

// ─── Front body regions matching reference image style ───────────────────────
// ViewBox: 0 0 200 440  (portrait)
// Numbered regions match the reference diagram layout

const FRONT_REGIONS = [
  // 1 - Left Head (from viewer's perspective, patient's right)
  { id: 'head-left',       label: 'Head (Left)',        num: 1,
    d: 'M 100 12 C 84 12 72 22 68 36 C 66 44 66 52 68 60 C 72 72 82 82 100 86 L 100 12 Z' },
  // 2 - Right Head
  { id: 'head-right',      label: 'Head (Right)',       num: 2,
    d: 'M 100 12 C 116 12 128 22 132 36 C 134 44 134 52 132 60 C 128 72 118 82 100 86 L 100 12 Z' },
  // 3 - Neck
  { id: 'neck',            label: 'Neck',               num: 3,
    d: 'M 88 86 L 112 86 L 114 106 L 86 106 Z' },
  // 4 - Left Shoulder
  { id: 'left-shoulder',   label: 'Left Shoulder',      num: 4,
    d: 'M 86 106 L 60 106 C 44 106 32 116 28 130 L 26 148 L 50 150 L 54 134 C 56 124 64 116 76 114 L 86 112 Z' },
  // 5 - Right Shoulder
  { id: 'right-shoulder',  label: 'Right Shoulder',     num: 5,
    d: 'M 114 106 L 140 106 L 146 114 C 156 116 164 124 166 134 L 170 150 L 150 150 L 146 134 C 144 124 136 116 120 112 Z' },
  // 6 - Left Upper Arm
  { id: 'left-upper-arm',  label: 'Left Upper Arm',     num: 6,
    d: 'M 26 148 L 50 150 L 46 192 L 24 188 Z' },
  // 7 - Right Upper Arm
  { id: 'right-upper-arm', label: 'Right Upper Arm',    num: 7,
    d: 'M 150 150 L 174 148 L 176 188 L 154 192 Z' },
  // 8 - Left Forearm
  { id: 'left-forearm',    label: 'Left Forearm',       num: 8,
    d: 'M 24 188 L 46 192 L 42 222 L 22 218 Z' },
  // 9 - Right Forearm
  { id: 'right-forearm',   label: 'Right Forearm',      num: 9,
    d: 'M 154 192 L 176 188 L 178 218 L 158 222 Z' },
  // 10 - Left Hand
  { id: 'left-hand',       label: 'Left Hand',          num: 10,
    d: 'M 22 218 L 42 222 L 38 240 C 32 250 14 248 10 236 C 8 226 14 218 22 218 Z' },
  // 11 - Right Hand
  { id: 'right-hand',      label: 'Right Hand',         num: 11,
    d: 'M 158 222 L 178 218 L 190 236 C 186 248 168 250 162 240 Z' },
  // 12 - Left Chest
  { id: 'left-chest',      label: 'Left Chest',         num: 12,
    d: 'M 76 114 L 100 114 L 100 158 L 70 158 L 70 130 Z' },
  // 13 - Right Chest
  { id: 'right-chest',     label: 'Right Chest',        num: 13,
    d: 'M 100 114 L 124 114 L 130 130 L 130 158 L 100 158 Z' },
  // 14 - Left Abdomen
  { id: 'left-abdomen',    label: 'Left Abdomen',       num: 14,
    d: 'M 70 158 L 100 158 L 100 204 L 72 204 Z' },
  // 15 - Right Abdomen
  { id: 'right-abdomen',   label: 'Right Abdomen',      num: 15,
    d: 'M 100 158 L 130 158 L 128 204 L 100 204 Z' },
  // 16 - Groin/Pelvis
  { id: 'pelvis',          label: 'Groin / Pelvis',     num: 16,
    d: 'M 72 204 L 128 204 L 130 224 L 70 224 Z' },
  // 17 - Left Thigh
  { id: 'left-thigh',      label: 'Left Thigh',         num: 17,
    d: 'M 70 224 L 100 224 L 98 294 L 70 294 Z' },
  // 18 - Right Thigh
  { id: 'right-thigh',     label: 'Right Thigh',        num: 18,
    d: 'M 100 224 L 130 224 L 130 294 L 102 294 Z' },
  // 19 - Left Lower Leg
  { id: 'left-lower-leg',  label: 'Left Lower Leg',     num: 19,
    d: 'M 70 318 L 96 318 L 92 376 L 72 376 Z' },
  // 20 - Right Lower Leg
  { id: 'right-lower-leg', label: 'Right Lower Leg',    num: 20,
    d: 'M 104 318 L 130 318 L 128 376 L 108 376 Z' },
  // 21 - Left Foot
  { id: 'left-foot',       label: 'Left Foot',          num: 21,
    d: 'M 72 376 L 92 376 C 92 388 84 400 68 402 C 54 402 48 392 50 382 C 54 376 64 376 72 376 Z' },
  // 22 - Right Foot
  { id: 'right-foot',      label: 'Right Foot',         num: 22,
    d: 'M 108 376 L 128 376 C 134 376 142 376 146 382 C 148 392 142 402 128 402 C 112 402 108 388 108 376 Z' },
  // 49 - Left Knee
  { id: 'left-knee',       label: 'Left Knee',          num: 49,
    d: 'M 70 294 L 98 294 C 98 306 98 318 96 318 L 70 318 C 68 318 68 306 70 294 Z' },
  // 50 - Right Knee
  { id: 'right-knee',      label: 'Right Knee',         num: 50,
    d: 'M 102 294 L 130 294 C 132 306 132 318 130 318 L 104 318 C 102 318 102 306 102 294 Z' },
];

const BACK_REGIONS = [
  // 23 - Left Head Back
  { id: 'head-left-b',        label: 'Head Back (Left)',   num: 23,
    d: 'M 100 12 C 84 12 72 22 68 36 C 66 44 66 52 68 60 C 72 72 82 82 100 86 L 100 12 Z' },
  // 24 - Right Head Back
  { id: 'head-right-b',       label: 'Head Back (Right)',  num: 24,
    d: 'M 100 12 C 116 12 128 22 132 36 C 134 44 134 52 132 60 C 128 72 118 82 100 86 L 100 12 Z' },
  // 25 - Neck Back
  { id: 'neck-back',          label: 'Neck (Back)',        num: 25,
    d: 'M 88 86 L 112 86 L 114 106 L 86 106 Z' },
  // 26 - Left Shoulder Back
  { id: 'left-shoulder-b',    label: 'Left Shoulder (Back)', num: 26,
    d: 'M 86 106 L 60 106 C 44 106 32 116 28 130 L 26 148 L 50 150 L 54 134 C 56 124 64 116 76 114 L 86 112 Z' },
  // 27 - Right Shoulder Back
  { id: 'right-shoulder-b',   label: 'Right Shoulder (Back)', num: 27,
    d: 'M 114 106 L 140 106 L 146 114 C 156 116 164 124 166 134 L 170 150 L 150 150 L 146 134 C 144 124 136 116 120 112 Z' },
  // 28 - Left Upper Arm Back
  { id: 'left-upper-arm-b',   label: 'Left Upper Arm (Back)', num: 28,
    d: 'M 26 148 L 50 150 L 46 192 L 24 188 Z' },
  // 29 - Right Upper Arm Back
  { id: 'right-upper-arm-b',  label: 'Right Upper Arm (Back)', num: 29,
    d: 'M 150 150 L 174 148 L 176 188 L 154 192 Z' },
  // 30 - Left Forearm Back
  { id: 'left-forearm-b',     label: 'Left Forearm (Back)', num: 30,
    d: 'M 24 188 L 46 192 L 42 222 L 22 218 Z' },
  // 31 - Right Forearm Back
  { id: 'right-forearm-b',    label: 'Right Forearm (Back)', num: 31,
    d: 'M 154 192 L 176 188 L 178 218 L 158 222 Z' },
  // 32 - Left Hand Back
  { id: 'left-hand-b',        label: 'Left Hand (Back)',   num: 32,
    d: 'M 22 218 L 42 222 L 38 240 C 32 250 14 248 10 236 C 8 226 14 218 22 218 Z' },
  // 33 - Right Hand Back
  { id: 'right-hand-b',       label: 'Right Hand (Back)',  num: 33,
    d: 'M 158 222 L 178 218 L 190 236 C 186 248 168 250 162 240 Z' },
  // 34 - Left Upper Back
  { id: 'left-upper-back',    label: 'Left Upper Back',    num: 34,
    d: 'M 76 114 L 100 114 L 100 158 L 70 158 L 70 130 Z' },
  // 35 - Right Upper Back
  { id: 'right-upper-back',   label: 'Right Upper Back',   num: 35,
    d: 'M 100 114 L 124 114 L 130 130 L 130 158 L 100 158 Z' },
  // 36 - Left Lower Back
  { id: 'left-lower-back',    label: 'Left Lower Back',    num: 36,
    d: 'M 70 158 L 100 158 L 100 204 L 72 204 Z' },
  // 37 - Right Lower Back
  { id: 'right-lower-back',   label: 'Right Lower Back',   num: 37,
    d: 'M 100 158 L 130 158 L 128 204 L 100 204 Z' },
  // 38 - Left Buttock
  { id: 'left-buttock',       label: 'Left Buttock',       num: 38,
    d: 'M 72 204 L 100 204 L 100 224 L 70 224 Z' },
  // 39 - Right Buttock
  { id: 'right-buttock',      label: 'Right Buttock',      num: 39,
    d: 'M 100 204 L 128 204 L 130 224 L 100 224 Z' },
  // 46 - Sacrum/Tailbone
  { id: 'sacrum',             label: 'Sacrum / Tailbone',  num: 46,
    d: 'M 90 196 L 110 196 L 112 212 L 88 212 Z' },
  // 40 - Left Thigh Back
  { id: 'left-thigh-b',       label: 'Left Thigh (Back)',  num: 40,
    d: 'M 70 224 L 100 224 L 98 294 L 70 294 Z' },
  // 41 - Right Thigh Back
  { id: 'right-thigh-b',      label: 'Right Thigh (Back)', num: 41,
    d: 'M 100 224 L 130 224 L 130 294 L 102 294 Z' },
  // 42 - Left Lower Leg Back
  { id: 'left-calf',          label: 'Left Calf',          num: 42,
    d: 'M 70 318 L 96 318 L 92 376 L 72 376 Z' },
  // 43 - Right Lower Leg Back
  { id: 'right-calf',         label: 'Right Calf',         num: 43,
    d: 'M 104 318 L 130 318 L 128 376 L 108 376 Z' },
  // 44 - Left Heel
  { id: 'left-heel',          label: 'Left Heel',          num: 44,
    d: 'M 72 376 L 86 376 L 84 396 C 78 404 62 402 58 392 C 56 384 62 376 72 376 Z' },
  // 45 - Right Heel
  { id: 'right-heel',         label: 'Right Heel',         num: 45,
    d: 'M 114 376 L 128 376 C 136 376 142 384 140 392 C 136 402 120 404 116 396 Z' },
  // 47 - Left Ankle
  { id: 'left-ankle',         label: 'Left Ankle',         num: 47,
    d: 'M 72 368 L 92 368 L 92 376 L 72 376 Z' },
  // 48 - Right Ankle
  { id: 'right-ankle',        label: 'Right Ankle',        num: 48,
    d: 'M 108 368 L 128 368 L 128 376 L 108 376 Z' },
  // Back Knee Left
  { id: 'left-knee-b',        label: 'Left Knee (Back)',   num: 'K',
    d: 'M 70 294 L 98 294 C 98 306 98 318 96 318 L 70 318 C 68 318 68 306 70 294 Z' },
  // Back Knee Right
  { id: 'right-knee-b',       label: 'Right Knee (Back)',  num: 'K',
    d: 'M 102 294 L 130 294 C 132 306 132 318 130 318 L 104 318 C 102 318 102 306 102 294 Z' },
];

const BodyLocationMapper = ({ selectedLocations, onToggle, otherLocationText, onOtherLocationTextChange }) => {
  const [view, setView] = useState('front');
  const [lastTapped, setLastTapped] = useState(null);

  const regions = view === 'front' ? FRONT_REGIONS : BACK_REGIONS;

  const handleRegionClick = (region) => {
    setLastTapped(region?.label);
    onToggle?.(region?.id);
  };

  const handleRemoveTag = (regionId) => {
    onToggle?.(regionId);
    const allRegions = [...FRONT_REGIONS, ...BACK_REGIONS];
    const region = allRegions?.find(r => r?.id === regionId);
    if (region && lastTapped === region?.label) {
      const remaining = selectedLocations?.filter(id => id !== regionId);
      if (remaining?.length > 0) {
        const lastRegion = allRegions?.find(r => r?.id === remaining?.[remaining?.length - 1]);
        setLastTapped(lastRegion?.label || null);
      } else {
        setLastTapped(null);
      }
    }
  };

  const getLabelForId = (id) => {
    const allRegions = [...FRONT_REGIONS, ...BACK_REGIONS];
    return allRegions?.find(r => r?.id === id)?.label || id;
  };

  const isSelected = (regionId) => selectedLocations?.includes(regionId);

  // Compute label centroid for number placement
  const getRegionCenter = (d) => {
    const nums = d?.match(/[\d.]+/g)?.map(Number) || [];
    const xs = [], ys = [];
    for (let i = 0; i < nums?.length - 1; i += 2) {
      xs?.push(nums?.[i]);
      ys?.push(nums?.[i + 1]);
    }
    if (!xs?.length) return { x: 100, y: 200 };
    return {
      x: xs?.reduce((a, b) => a + b, 0) / xs?.length,
      y: ys?.reduce((a, b) => a + b, 0) / ys?.length,
    };
  };

  return (
    <div className="space-y-4">
      {/* Header */}
      <div className="mb-2">
        <h3 className="text-lg md:text-xl lg:text-2xl font-heading font-bold text-foreground mb-1">
          Where do you feel it?
        </h3>
        <p className="text-sm md:text-base text-muted-foreground">
          Tap the body areas affected
        </p>
      </div>
      {/* Front / Back toggle */}
      <div className="flex justify-center">
        <div className="inline-flex rounded-xl border border-border bg-muted p-1 gap-1">
          <button
            onClick={() => setView('front')}
            className={`px-5 py-2 rounded-lg text-sm font-medium transition-all ${
              view === 'front' ? 'bg-primary text-primary-foreground shadow-sm' : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            Front View
          </button>
          <button
            onClick={() => setView('back')}
            className={`px-5 py-2 rounded-lg text-sm font-medium transition-all ${
              view === 'back' ? 'bg-primary text-primary-foreground shadow-sm' : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            Back View
          </button>
        </div>
      </div>
      {/* SVG Body Map */}
      <div className="flex flex-col items-center">
        <div className="relative w-full max-w-[240px] mx-auto bg-white rounded-2xl border border-gray-200 shadow-sm p-2">
          <svg
            viewBox="0 0 200 420"
            xmlns="http://www.w3.org/2000/svg"
            className="w-full h-auto"
            aria-label={`Interactive ${view} body map`}
          >
            {/* ── Body silhouette background ── */}
            {/* Head */}
            <ellipse cx="100" cy="50" rx="32" ry="38" fill="#f5f5f5" stroke="#374151" strokeWidth="1.5" />
            {/* Neck */}
            <rect x="88" y="86" width="24" height="20" rx="2" fill="#f5f5f5" stroke="#374151" strokeWidth="1.5" />
            {/* Torso */}
            <path d="M 70 106 L 130 106 L 132 224 L 68 224 Z" fill="#f5f5f5" stroke="#374151" strokeWidth="1.5" />
            {/* Left arm */}
            <path d="M 26 148 L 50 150 L 42 240 C 32 252 10 248 8 234 C 6 222 14 218 22 218 L 24 188 L 26 148 Z" fill="#f5f5f5" stroke="#374151" strokeWidth="1.5" />
            {/* Right arm */}
            <path d="M 174 148 L 150 150 L 158 240 C 168 252 190 248 192 234 C 194 222 186 218 178 218 L 176 188 L 174 148 Z" fill="#f5f5f5" stroke="#374151" strokeWidth="1.5" />
            {/* Left leg */}
            <path d="M 68 224 L 100 224 L 98 294 L 96 318 L 92 376 C 84 402 50 402 50 382 C 48 372 58 368 72 368 L 72 376 L 72 376 L 70 318 L 70 294 Z" fill="#f5f5f5" stroke="#374151" strokeWidth="1.5" />
            {/* Right leg */}
            <path d="M 132 224 L 100 224 L 102 294 L 104 318 L 108 376 C 116 402 150 402 150 382 C 152 372 142 368 128 368 L 128 376 L 130 318 L 130 294 Z" fill="#f5f5f5" stroke="#374151" strokeWidth="1.5" />

            {/* ── Facial features (front only) ── */}
            {view === 'front' && (
              <>
                <line x1="100" y1="14" x2="100" y2="84" stroke="#9ca3af" strokeWidth="0.8" strokeDasharray="2,2" />
                <ellipse cx="88" cy="48" rx="5" ry="4" fill="#d1d5db" />
                <ellipse cx="112" cy="48" rx="5" ry="4" fill="#d1d5db" />
                <path d="M 100 56 L 97 62 Q 100 65 103 62 Z" fill="#d1d5db" />
                <path d="M 93 70 Q 100 75 107 70" fill="none" stroke="#d1d5db" strokeWidth="1.2" strokeLinecap="round" />
              </>
            )}
            {view === 'back' && (
              <line x1="100" y1="14" x2="100" y2="84" stroke="#9ca3af" strokeWidth="0.8" strokeDasharray="2,2" />
            )}

            {/* ── Torso dividing lines ── */}
            {/* Vertical midline torso */}
            <line x1="100" y1="106" x2="100" y2="224" stroke="#9ca3af" strokeWidth="0.8" strokeDasharray="2,2" />
            {/* Chest / abdomen divider */}
            <line x1="70" y1="158" x2="130" y2="158" stroke="#9ca3af" strokeWidth="0.8" />
            {/* Abdomen / pelvis divider */}
            <line x1="70" y1="204" x2="130" y2="204" stroke="#9ca3af" strokeWidth="0.8" />
            {/* Shoulder lines */}
            <line x1="70" y1="106" x2="50" y2="150" stroke="#9ca3af" strokeWidth="0.8" />
            <line x1="130" y1="106" x2="150" y2="150" stroke="#9ca3af" strokeWidth="0.8" />
            {/* Arm dividers */}
            <line x1="26" y1="148" x2="50" y2="150" stroke="#9ca3af" strokeWidth="0.8" />
            <line x1="24" y1="188" x2="46" y2="192" stroke="#9ca3af" strokeWidth="0.8" />
            <line x1="150" y1="150" x2="174" y2="148" stroke="#9ca3af" strokeWidth="0.8" />
            <line x1="154" y1="192" x2="176" y2="188" stroke="#9ca3af" strokeWidth="0.8" />
            {/* Leg dividers */}
            <line x1="70" y1="294" x2="98" y2="294" stroke="#9ca3af" strokeWidth="0.8" />
            <line x1="70" y1="318" x2="96" y2="318" stroke="#9ca3af" strokeWidth="0.8" />
            <line x1="70" y1="368" x2="92" y2="368" stroke="#9ca3af" strokeWidth="0.8" />
            <line x1="102" y1="294" x2="130" y2="294" stroke="#9ca3af" strokeWidth="0.8" />
            <line x1="104" y1="318" x2="130" y2="318" stroke="#9ca3af" strokeWidth="0.8" />
            <line x1="108" y1="368" x2="128" y2="368" stroke="#9ca3af" strokeWidth="0.8" />
            {/* Knee caps */}
            <ellipse cx="83" cy="306" rx="11" ry="8" fill="none" stroke="#9ca3af" strokeWidth="0.8" />
            <ellipse cx="117" cy="306" rx="11" ry="8" fill="none" stroke="#9ca3af" strokeWidth="0.8" />
            {/* Collarbone */}
            <path d="M 76 114 Q 100 110 124 114" fill="none" stroke="#9ca3af" strokeWidth="0.8" strokeLinecap="round" />
            {/* Navel */}
            <circle cx="100" cy="180" r="2.5" fill="none" stroke="#9ca3af" strokeWidth="1" />

            {/* ── Clickable regions (transparent, on top) ── */}
            {regions?.map(region => {
              const selected = isSelected(region?.id);
              const center = getRegionCenter(region?.d);
              return (
                <g key={region?.id} onClick={() => handleRegionClick(region)} style={{ cursor: 'pointer' }}>
                  <path
                    d={region?.d}
                    fill={selected ? 'rgba(34,197,94,0.55)' : 'rgba(0,0,0,0)'}
                    stroke={selected ? '#16a34a' : 'rgba(0,0,0,0)'}
                    strokeWidth={selected ? 1.5 : 0}
                    className="transition-all duration-150"
                    style={{ touchAction: 'manipulation' }}
                    role="button"
                    aria-label={`${region?.label}${selected ? ' (selected)' : ''}`}
                    aria-pressed={selected}
                    onMouseEnter={e => { if (!selected) e?.currentTarget?.setAttribute('fill', 'rgba(34,197,94,0.18)'); }}
                    onMouseLeave={e => { if (!selected) e?.currentTarget?.setAttribute('fill', 'rgba(0,0,0,0)'); }}
                  />
                  {/* Region number label */}
                  <text
                    x={center?.x}
                    y={center?.y + 4}
                    textAnchor="middle"
                    fontSize="7"
                    fontWeight="600"
                    fill={selected ? '#fff' : '#374151'}
                    style={{ pointerEvents: 'none', userSelect: 'none' }}
                  >
                    {region?.num}
                  </text>
                </g>
              );
            })}
          </svg>
        </div>

        {/* Last tapped body part name display */}
        <div className="mt-3 min-h-[36px] flex items-center justify-center">
          {lastTapped ? (
            <div className="flex items-center gap-2 bg-primary/10 border border-primary/30 rounded-full px-4 py-1.5">
              <div className="w-2 h-2 rounded-full bg-primary" />
              <span className="text-sm font-semibold text-primary">{lastTapped}</span>
            </div>
          ) : (
            <p className="text-xs text-muted-foreground italic">Tap a region to select it</p>
          )}
        </div>
      </div>
      {/* Selected body part tags */}
      {selectedLocations?.length > 0 && (
        <div className="mt-2">
          <p className="text-xs font-medium text-muted-foreground mb-2">Selected areas:</p>
          <div className="flex flex-wrap gap-2">
            {selectedLocations?.map(id => (
              <span
                key={id}
                className="inline-flex items-center gap-1.5 bg-primary/10 border border-primary/30 text-primary text-xs font-medium rounded-full px-3 py-1.5"
              >
                {getLabelForId(id)}
                <button
                  onClick={() => handleRemoveTag(id)}
                  className="flex items-center justify-center w-4 h-4 rounded-full hover:bg-primary/20 transition-colors"
                  aria-label={`Remove ${getLabelForId(id)}`}
                >
                  <X size={10} strokeWidth={2.5} />
                </button>
              </span>
            ))}
          </div>
        </div>
      )}
      {/* Voice / Text input for exact location */}
      <div className="mt-4 rounded-xl border border-border bg-muted/40 p-4 space-y-3">
        <div className="flex items-center justify-between">
          <label className="text-sm font-medium text-foreground">
            Describe exact location
          </label>
          <VoiceInputButton
            value={otherLocationText || ''}
            onChange={(text) => onOtherLocationTextChange?.(text)}
            maxLength={500}
          />
        </div>
        <input
          type="text"
          value={otherLocationText || ''}
          onChange={(e) => onOtherLocationTextChange?.(e?.target?.value)}
          placeholder="e.g. left ankle, right elbow, index finger"
          maxLength={500}
          className="w-full px-3 py-2.5 rounded-lg border border-border bg-background text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary transition-colors"
        />
        <p className="text-xs text-muted-foreground">
          Speak or type to pinpoint the exact spot — this will be combined with your map selections.
        </p>
      </div>
    </div>
  );
};

export default BodyLocationMapper;